import { render, staticRenderFns } from "./popup_add_edit_comment.vue?vue&type=template&id=2ca2bc1f&scoped=true&lang=pug"
import script from "./popup_add_edit_comment.vue?vue&type=script&lang=js"
export * from "./popup_add_edit_comment.vue?vue&type=script&lang=js"
import style0 from "../../assets/koromo_min.css?vue&type=style&index=0&id=2ca2bc1f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2bc1f",
  null
  
)

export default component.exports